import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("do_lang") || "en");
  useEffect(() => { localStorage.setItem("do_lang", lang); }, [lang]);
  const t = dict[lang] || dict.en;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
